import { useCallback } from "react";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { useCreateSnackFormBaseModel } from "../../../../_shared/model/use-create-snack-form-base-model";
import { type ServerModel } from "../../../../_shared/model/use-create-snack-form-base-model/type";
import { useSnackCreateMutation } from "../../repository/mutation/use-snack-create-mutation";

import type { SnackFormBaseModelMethodsType } from "../../../../_shared/model/use-create-snack-form-base-model/methods";
import type { DesignSnackFormBaseModel } from "../../../../_shared/model/use-create-snack-form-base-model/type";

type Props = {
	hotelID: string;
	data: ServerModel;
};

export type SnackFormModelType = {
	viewModel: DesignSnackFormBaseModel["ViewModel"];
	onUpdate: () => Promise<void>;
	methods: SnackFormBaseModelMethodsType;
};

export const useCreateSnackFormModel = ({ hotelID, data }: Props): SnackFormModelType => {
	const { viewModel, resetViewModel, methods } = useCreateSnackFormBaseModel({
		hotelID,
		data,
	});

	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { onUpdate: _onUpdate } = useSnackCreateMutation();
	const onUpdate = useCallback(async () => {
		showLoadingScreenCallback();

		await _onUpdate({ viewModel })
			.then(({ errors }) => {
				if (!errors) {
					notifyUserEventInfo({ variant: "default", title: "スナックの基本情報の設定を更新しました" });
					resetViewModel();
				}
			})
			.finally(() => hideLoadingScreenCallback());
	}, [showLoadingScreenCallback, _onUpdate, viewModel, resetViewModel, hideLoadingScreenCallback]);

	return {
		viewModel,
		methods,
		onUpdate,
	};
};
